console.log('[FBB] ctr-product-alp-multi-flavor-buy-box.js LOADED');
document.addEventListener('alpine:init', () => {
  Alpine.data('ProductCard', (id) => ({
    id,
    mainSlider: null,
    mainSliderThumbs: null,
    mainProduct: {},            // { id, title, options, variants }
    variantsMetafield: {},      // { id, metadata }
    optionsName: [],            // ['Color', 'Size']
    options: {},                // { Color: ['Red', 'Blue'], Size: ['S', 'M'] }
    variants: [],               // [{ id, title, options: { Color: 'Red', Size: 'M' }, ... }]
    selectedOptions: {},        // { Color: 'Red', Size: 'M' }
    selectedVariant: null,
    finalVariantIdsMap: {},
    inputVariantId: null,       // The variant ID to be used in the input field for the form submission
    skioSellingPlanGroups: [],  // Store Skio-specific selling plan groups

    isVisible: false,
    offsetTop: 0,

    // Use First image as default
    firstImageVariant: true,
    skipFirstVariantSlide: false,

    // Multi-variants product handling methods
    firstOption: '',
    secondOption: '',
    selectedVariants: [],
    selectedOptionMulti: '',
    multiVariants: false,
    imgModalSrc: '',
    modalOpen: false,
    qty: 1,

    // Flavor preselect — guards against double-seeding across init/initNewProduct
    _fbbSeeded: false,

    /**
     * Initialize the component with default data
     */
    init() {
      this.firstOption  = this.$refs.firstOption?.value || '';
      this.secondOption = this.$refs.secondOption?.value || '';
      // debugger;
      this.inputVariantId = document.querySelector('.b-skio__form .product-variant-id'); // Get the variant ID input field
      this.skipFirstVariantSlide = this.firstImageVariant === true;
      console.log('First image variant is set to:', this.skipFirstVariantSlide);

      this.initSlider();                                          // Initialize the Splide sliders
      this.parseProductJson();                                    // Parse the product JSON from the DOM
      this.loadHiddenVariantIds();                                // Load hidden variant IDs from metafield JSON
      this.filterSkioSellingPlans();                              // Filter for Skio selling plans only
      this.mapOptions();                                          // Extract all unique option values
      this.mapVariants();                                         // Map all variants with named option objects
      this.selectDefaultOptions();                                // Select the default variant and options
      this.setSelectedVariantStore(this.selectedVariant);         // Push the selected variant to Alpine store 
      this.selectVariantMulti(this.selectedVariant.id, 0, true);  // Set default multi-variant selection

      this.stickyBanner(); // Initialize sticky banner behavior
      this.initVariantLeadPosition(); // Start at slide 1 if variant-lead slot is present

      console.log('[FBB] init() complete. Keys in option2 map:', Object.keys(this.finalVariantIdsMap?.option2 || {}));

      this.skipFirstVariantSlide = false;

      // Flavor preselect. Deferred because each tile's x-data scope is initialized by
      // Alpine only after this init() returns, and the seed writes into those scopes.
      this.$nextTick(() => this.preselectFirstFlavor());

    },

    // Modal window
    openModal(imgSrc) {
      this.modalOpen = true;
      this.imgModalSrc = imgSrc;
      console.log('Opening modal with image:', imgSrc);
      document.body.classList.add('is-modal-open');
    },
    
    closeModal() {
      this.modalOpen = false;
      this.imgModalSrc = '';
      document.body.classList.remove('is-modal-open');
    },
 
    stickyBanner() {
      const el = document.querySelector('.product-form__buttons.m-skio-variants.m-sticky');
      if (!el) return;
    
      const elchild = el.querySelector('.product-form__sticky');
      if (!elchild) return;
    
      const triggerOffset = el.offsetTop;
      const elementHeight = el.offsetHeight;
      // el.style.height = `${elementHeight}px`;
    
      window.addEventListener('scroll', () => {
        const scrollY = window.scrollY || window.pageYOffset;
    
        if (scrollY > triggerOffset + elementHeight) {
          elchild.classList.add('m-activated');
        } else {
          elchild.classList.remove('m-activated');
        }
      });
    },
 
    // Show the slide corresponding to the selected variant
    showVariantSlide(variant) {
      if (!this.mainSlider || !variant) return;

      // If gallery has a single variant-lead slide — scroll to it so the user sees the new image
      const variantLeadSlide = document.querySelector(`#MainSlider-${this.id} .splide__slide--variant-lead`);
      if (variantLeadSlide) {
        this.mainSlider.go(0);
        return;
      }

      // Fallback: original data-variant-ids logic for non-metafield galleries
      const thumbs = document.querySelectorAll(
        `#ThumbnailSlider-${this.id} .thumbnail-slide[data-variant-ids]`
      );
      let targetIndex = null;

      thumbs.forEach((thumb) => {
        const variantIdsAttr = thumb.getAttribute('data-variant-ids');
        if (!variantIdsAttr) return;
        const variantIds = variantIdsAttr.split(',').map((value) => value.trim());
        if (variantIds.includes(variant.id.toString())) {
          targetIndex = parseInt(thumb.dataset.index, 10);
        }
      });

      if (targetIndex !== null && Number.isFinite(targetIndex)) {
        this.mainSlider.go(targetIndex);
      }
    },

    // If a variant-lead slide exists, start gallery at slide 1 (first metafield image)
    initVariantLeadPosition() {
      if (!this.mainSlider) return;
      const variantLeadSlide = document.querySelector(`#MainSlider-${this.id} .splide__slide--variant-lead`);
      if (variantLeadSlide) {
        this.mainSlider.go(1);
      }
    },

    initSlider() {
      this.mainSlider = new Splide(`#MainSlider-${ this.id }`, {
        type: 'slide',
        rewind: true,
        pagination: false,
        arrows: true,
        breakpoints: {
          749: {
            arrows: false,
          },
        },
      });
  
      this.thumbnailSlider = new Splide(`#ThumbnailSlider-${ this.id }`, {
        fixedWidth: 65,
        fixedHeight: 65,
        gap: 15,
        rewind: true,
        pagination: false,
        isNavigation: true,
        arrows: false,
        breakpoints: {
          640: {
            fixedWidth: 55,
            fixedHeight: 55,
            gap: 10,
          },
        }, 
      });
  
      this.mainSlider.sync(this.thumbnailSlider);
      this.mainSlider.mount();
      this.thumbnailSlider.mount();
    },
 
    /** 
     * Parse the product JSON from a DOM reference
     */
    parseProductJson() {
      const productData = JSON.parse(this.$refs.productDataJson.textContent);
      const productVariantsMetafieldJson = JSON.parse(this.$refs.productVariantsMetafieldJson.textContent);
      this.mainProduct = productData || null;
      this.variantsMetafield = productVariantsMetafieldJson;
      console.log('this.mainProduct', this.mainProduct);
      console.log('this.variantsMetafield', this.variantsMetafield);
    },

    /**
     * Filter selling plan groups to only include Skio plans
     */
    filterSkioSellingPlans() {
      this.skioSellingPlanGroups = window.CtrSkioPlans.skioGroups(this.mainProduct);

      console.log('Skio selling plan groups:', this.skioSellingPlanGroups);

      this.skioSellingPlanIds = new Set();
      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans?.forEach((plan) => {
          this.skioSellingPlanIds.add(plan.id);
        });
      });

      console.log('Skio selling plan IDs:', Array.from(this.skioSellingPlanIds));
    },

    /**
     * Check if a selling plan allocation is from Skio
     * @param {Object} allocation - The selling plan allocation
     * @returns {Boolean}
     */
    isSkioSellingPlan(allocation) {
      return this.skioSellingPlanIds?.has(allocation.selling_plan_id) || false;
    },

    /**
     * Get Skio selling plan by ID
     * @param {Number} planId - The selling plan ID
     * @returns {Object|null} - The selling plan object or null
     */
    getSkioSellingPlan(planId) {
      for (const group of this.skioSellingPlanGroups) {
        const plan = group.selling_plans?.find(sp => sp.id === planId);
        if (plan) return plan;
      }
      return null;
    },

    /**
     * Initialize the component with a new product
     * @param {Object} product - The new product object
     */
    initNewProduct(product) {
      this.mainProduct = product;
      this.init();
    },

    /**
     * Map all available product options and their unique values
     */ 
    mapOptions() {
      this.options = {};
      this.optionsName = [];

      if (!this.mainProduct || !this.mainProduct.options) return;

      this.mainProduct.options.forEach((option, index) => {
        const key = `option${index + 1}`;
        this.optionsName.push(option);
        this.options[key] = this.mainProduct.variants
          .map(v => v.options[index])
          .filter((value, i, arr) => arr.indexOf(value) === i);
      });
    },

    /** 
     * Create a normalized list of variants with key-value pair options
     * Only include Skio selling plan allocations
     */
    // Read hidden variant IDs output by ctr-product-variant-picker-multiply.liquid
    loadHiddenVariantIds() {
      const el = document.getElementById('hidden-variant-ids-' + this.id);
      try {
        this.hiddenVariantIds = new Set(el ? JSON.parse(el.textContent) : []);
      } catch (e) {
        this.hiddenVariantIds = new Set();
      }
    },

    mapVariants() {
      this.variants = this.mainProduct.variants
      .filter(variant => !this.hiddenVariantIds.has(variant.id))
      .map(variant => {
        const optionsObj = {};

        this.mainProduct.options.forEach((opt, i) => {
          const key = `option${i + 1}`;
          optionsObj[key] = variant.options[i];
        });

        const rawAllocations = variant.selling_plan_allocations || [];
        let skioAllocations = rawAllocations.filter((allocation) =>
          this.isSkioSellingPlan(allocation)
        );
        if (skioAllocations.length === 0 && rawAllocations.length > 0) {
          skioAllocations = rawAllocations;
        }

        const matchedMeta = this.variantsMetafield?.find(m => m.id === variant.id);
        return {
          ...variant,
          optionsMapped: optionsObj,
          selling_plan_allocations: skioAllocations, // Only Skio allocations
          metafields: matchedMeta?.metafields || {},
        };
      });
      console.log('this.variants', this.variants); 
    },

  /**
   * Set the default selected options.
   * If the URL contains a ?variant=ID, use that variant's options.
   * Otherwise, fallback to the first available variant.
   */
  selectDefaultOptions() {
      if (this.variants.length === 0) return;
  
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get('variant');
  
      if (variantIdFromUrl && /^\d+$/.test(variantIdFromUrl)) {
          const matchedVariant = this.variants.find(v => v.id.toString() === variantIdFromUrl);
          
          if (matchedVariant) { 

              this.selectedOptions = { ...matchedVariant.optionsMapped };
              this.selectedOptionMulti = this.selectedOptions.option1;
              this.selectedVariant = matchedVariant;
              const lastKey = `option${this.optionsName.length}`;
            
              this.updateFinalVariantMap(lastKey);
              return;
          } 
      }
  
      // fallback if variant param not found or invalid
      this.selectedOptions = { ...this.variants[0].optionsMapped };
      this.selectedOptionMulti = this.selectedOptions.option1;
      
      this.selectedVariant = this.variants[0];
      const lastKey = `option${this.optionsName.length}`;
      this.updateFinalVariantMap(lastKey);
  }, 

    /**
     * Push the currently selected variant to the Alpine store
     * @param {Object} variant - The selected product variant object
     */
    setSelectedVariantStore(variant) {
      const shouldSlide = this.skipFirstVariantSlide ? false : true;
      if (shouldSlide) {
        this.showVariantSlide(variant);
      }

      if (!variant || typeof variant !== 'object') return;

      Alpine.store('ProductStore').set(variant);
      // Set the variant ID in the input field for form submission
      if (this.inputVariantId) {
        this.inputVariantId.value = variant.id;
      }
       
      let skioAllocations = variant.selling_plan_allocations?.filter((allocation) =>
        this.isSkioSellingPlan(allocation)
      );
      if (!skioAllocations?.length && variant.selling_plan_allocations?.length) {
        skioAllocations = variant.selling_plan_allocations;
      }
      const planId = skioAllocations?.[0]?.selling_plan_id;

      if (planId) {
        Alpine.store('ProductStore').setSellingPlanForVariant(planId);
      }
    },

    /**
     * Update the selected option for a given option name
     * @param {String} name - Option name (e.g. "Option1")
     * @param {String} value - Selected value (e.g. "Red")
     */
    selectOption(name, value) {
        this.selectedOptions[name] = value;
        this.selectVariantFromOption(); 
        const lastKey = `option${this.optionsName.length}`;
        this.updateFinalVariantMap(lastKey);
    },

    selectOptionMulti(value) {
      this.selectedOptionMulti = value;
      if (value === this.secondOption && this.selectedVariants.length > 1) {
        this.multiVariants = true;
      } else if (value === this.secondOption && this.selectedVariants.length === 1) {
        this.selectedVariants[1] = this.selectedVariants[0];
        this.multiVariants = true;
      } else {
        this.multiVariants = false;
        this.setQty(1, value);
      }
      Alpine.store('ProductStore').setMultiVariants(this.multiVariants);
      console.log('this.multiVariants:', this.multiVariants);  
    },

    setQty(value, option) {
      this.selectedOptionMulti = option;
      this.qty = value;
      Alpine.store('ProductStore').setQty(this.qty);
    },

    /**
     * Find and set the selected variant based on current selectedOptions
     */
    selectVariantFromOption() {
        this.selectedVariant = this.variants.find(v => {
            return Object.entries(this.selectedOptions).every(([key, value]) => {
            return v.optionsMapped[key] === value;
            });
        }) || null;

        // Update the URL with the selected variant ID
        if (this.selectedVariant) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', this.selectedVariant.id);
            window.history.replaceState({}, '', url);
            // Push to Alpine store
            this.setSelectedVariantStore(this.selectedVariant);
            console.log('Selected variant:', this.selectedVariant);
        }
    },

    selectVariantById(variantId) {
      
      const matchedVariant = this.variants.find(v => v.id === variantId);
      if (matchedVariant) {
        this.selectedVariant = matchedVariant;
        console.log('Selected variant by ID:', this.selectedVariant);
        this.selectedOptions = { ...matchedVariant.optionsMapped };
        this.setSelectedVariantStore(matchedVariant);
        const lastKey = `option${this.optionsName.length}`;
        this.updateFinalVariantMap(lastKey);
      }
    },
 
    
    selectVariantMulti(variantId, key, setDef = false) {
      const matchedVariant = this.variants.find(v => v.id === variantId);
      if (matchedVariant) {  
        this.selectedVariants[key] = matchedVariant.id;
        Alpine.store('ProductStore').setSelectedVariants(this.selectedVariants);
        
        if (key === 1) {
          Alpine.store('ProductStore').setMultiVariants(true);
        } else if (key === 0 && this.selectedVariants.length > 1 && this.selectedOptionMulti === this.secondOption) {
          Alpine.store('ProductStore').setMultiVariants(true);
          // debugger;
          // console.log('Multi-variant selected. TEST');
        } else if (key === 0 && this.selectedVariants.length > 1 && this.selectedOptionMulti === this.firstOption) {
          Alpine.store('ProductStore').setMultiVariants(false);
        } else {
          Alpine.store('ProductStore').setMultiVariants(false);
        }
        
        console.log('Selected variants:', this.selectedVariants);
      } 

      if (setDef) {
        this.selectVariantById(variantId);
        console.log('Selected single variant for form submission:', this.selectedVariant);
      }
    },

    /**
     * Get mapping of option values to variant IDs for the final option level.
     * This can be used to render buttons with attached variant IDs.
     * Uses only Skio selling plan data.
     * @param {String} optionKey - like "option3"
     * @returns {Object} - { "Black": 1234567890, "White": 1234567891 }
     */ 
    updateFinalVariantMap(optionKey) {
      console.log('[FBB] updateFinalVariantMap called', { optionKey, selectedOptions: {...this.selectedOptions}, variantsCount: this.variants.length });

      const filtered = this.variants.filter(v => {
        return Object.entries(this.selectedOptions).every(([key, value]) => {
          return key === optionKey || v.optionsMapped[key] === value;
        });
      });

      console.log('[FBB] filtered variants:', filtered.length, filtered.map(v => v.optionsMapped));

      if (filtered.length === 0) {
        console.warn('[FBB] No filtered variants — map will be empty');
        this.finalVariantIdsMap[optionKey] = {};
        return;
      }
    
      const map = {};
    
      filtered.forEach(v => {
        const rawAllocations = v.selling_plan_allocations || [];
        let skioAllocations = rawAllocations.filter((allocation) =>
          this.isSkioSellingPlan(allocation)
        );
        if (!skioAllocations.length && rawAllocations.length) {
          skioAllocations = rawAllocations;
        }

        const value = v.optionsMapped[optionKey];

        if (!skioAllocations || skioAllocations.length === 0) {
          console.log('[FBB] No selling plans for variant, adding with available:', v.available, 'value:', value);
          map[value] = {
            id: v.id,
            available: v.available,
            ...(v.metafields ? { metafields: v.metafields } : {}),
            servingSubscribe: null,
            servingOneTime: null
          };
          return;
        }

        const allocation = skioAllocations[0];
        const priceRaw = allocation.price;
        const compareAtRaw = allocation.compare_at_price;
        const sellingPlanId = allocation.selling_plan_id;
    
        // Default to 30 days in a month
        let dayCount = 30;
    
        // Find matching Skio selling plan by ID
        const sellingPlan = this.getSkioSellingPlan(sellingPlanId);
        const sellingPlanName = sellingPlan?.name || '';
    
        // Adjust days based on plan name
        if (sellingPlanName.includes("1 Month")) {
          dayCount *= 1;
        } else if (sellingPlanName.includes("2 Month")) {
          dayCount *= 2;
        } else if (sellingPlanName.includes("3 Month")) {
          dayCount *= 3;
        }
    
        const servingSubscribe = typeof priceRaw === 'number'
          ? (priceRaw / dayCount / 100).toFixed(2)
          : null;
    
        const servingOneTime = typeof compareAtRaw === 'number'
          ? (compareAtRaw / dayCount / 100).toFixed(2)
          : null;
    
        map[value] = {
          id: v.id,
          available: v.available,
          ...(v.metafields ? { metafields: v.metafields } : {}),
          servingSubscribe,
          servingOneTime
        };
      });
    
      console.log('[FBB] final map for', optionKey, map);
      this.finalVariantIdsMap = {
        ...this.finalVariantIdsMap,
        [optionKey]: map
      };
    },

    hasBadgeValue(key, value, field) {
      const val = this.finalVariantIdsMap?.[key]?.[value]?.metafields?.[field];
      // Check if the value is not null, undefined, or an empty string
      if (val !== undefined && val !== null && val !== '') {
        return true;
      }
        return false;
    },

    /**
     * Read the preselect config emitted by ctr-product-option-picker-flavor-buy-box.liquid.
     * Returns null when the section setting is off — no JSON tag is rendered at all, so
     * sections that share the picker snippet without the setting simply no-op here.
     * @returns {Object|null}
     */
    getFbbPreselectConfig() {
      const el = document.getElementById(`ctr-fbb-preselect-${this.id}`);
      if (!el) return null;
      try {
        const cfg = JSON.parse(el.textContent);
        return cfg && cfg.enabled ? cfg : null;
      } catch (e) {
        console.warn('[FBB] preselect config parse failed:', e);
        return null;
      }
    },

    /**
     * Seed a quantity on a flavor tile at load so Add to Cart renders live and priced
     * instead of "ADD A FLAVOR TO CONTINUE".
     *
     * Availability is read from finalVariantIdsMap (built by updateFinalVariantMap), not
     * from Liquid — inventory for this picker is only resolved client-side, so seeding at
     * Liquid time could put a qty on a sold-out variant behind a disabled button.
     *
     * @param {Number} attempt - internal retry counter for tile scope readiness
     */
    preselectFirstFlavor(attempt = 0) {
      const cfg = this.getFbbPreselectConfig();
      if (!cfg || this._fbbSeeded) return;

      const root = this.$refs.product_card_element || document;
      const picker = root.querySelector('.b-option_selector.m-flavor-buy-box');
      if (!picker) return;

      // Flavor level is always the last option group — option1 is the hidden size level.
      // With a single option group the box carries both m-first and m-last, so this holds.
      const box = picker.querySelector('.b-option_selector--box.m-last')
        || picker.querySelector('.b-option_selector--box:last-of-type');
      if (!box || box.dataset.ctrFbbSeeded === '1') return;

      const tiles = Array.from(box.querySelectorAll('.b-fbb-flavor-tile'));
      if (!tiles.length) return;

      const scopeOf = (tile) => {
        try { return Alpine.$data(tile); } catch (e) { return null; }
      };

      // Tile x-data scopes are initialized after this component's init() returns, so
      // retry on a bounded rAF loop rather than assuming they exist on first pass.
      const firstScope = scopeOf(tiles[0]);
      if ((!firstScope || typeof firstScope.localQty === 'undefined') && attempt < 20) {
        requestAnimationFrame(() => this.preselectFirstFlavor(attempt + 1));
        return;
      }

      const lastKey = `option${this.optionsName.length}`;
      const map = this.finalVariantIdsMap?.[lastKey] || {};

      const isSeedable = (tile) => {
        const value = tile.dataset.optionValue;
        const entry = value ? map[value] : null;
        return !!entry && entry.available !== false;
      };

      let target = null;
      if (cfg.soldOutBehavior === 'strict') {
        // Only ever seed the literal first flavor; if it's out, seed nothing.
        if (isSeedable(tiles[0])) target = tiles[0];
      } else {
        target = tiles.find(isSeedable) || null;
      }

      // Nothing seedable — leave the picker in its empty state rather than putting a
      // quantity on a dead variant the shopper can't check out with.
      if (!target) {
        this._fbbSeeded = true;
        box.dataset.ctrFbbSeeded = '1';
        console.log('[FBB] preselect skipped — no seedable flavor');
        return;
      }

      const scope = scopeOf(target);
      if (!scope || typeof scope.localQty === 'undefined') {
        if (attempt < 20) requestAnimationFrame(() => this.preselectFirstFlavor(attempt + 1));
        return;
      }

      // Shopper already has a qty here (bfcache restore, customizer re-render) — respect it.
      if (scope.localQty > 0) {
        this._fbbSeeded = true;
        box.dataset.ctrFbbSeeded = '1';
        return;
      }

      const qty = Number.isFinite(cfg.qty) && cfg.qty > 0 ? Math.floor(cfg.qty) : 1;
      scope.localQty = qty;

      // Off by default: matches the screenshot, where the seeded tile shows its qty badge
      // and stepper with no selected ring and no gallery jump on load.
      if (cfg.highlight) {
        try {
          scope.isSelected = true;
          this.selectOption(lastKey, target.dataset.optionValue);
        } catch (e) {
          console.warn('[FBB] preselect highlight failed:', e);
        }
      }

      this._fbbSeeded = true;
      box.dataset.ctrFbbSeeded = '1';
      console.log('[FBB] preselected flavor:', target.dataset.optionValue, 'qty:', qty);

      this.$nextTick(() => this.notifyFbbQtyChange(target, qty));
    },

    /**
     * The Skio component derives its totals from flavor qty. Nudge it after a seeded
     * change in case those totals are click/event driven rather than reactive on the
     * tiles' [data-qty] binding.
     * @param {HTMLElement} tile
     * @param {Number} qty
     */
    notifyFbbQtyChange(tile, qty) {
      try {
        tile.dispatchEvent(new CustomEvent('ctr:fbb-qty-change', {
          bubbles: true,
          detail: { qty, seeded: true }
        }));
      } catch (e) {}

      try {
        const store = Alpine.store('ProductStore');
        if (!store) return;
        if (typeof store.recalculateFBB === 'function') store.recalculateFBB();
        else if (typeof store.updateFBBTotals === 'function') store.updateFBBTotals();
        else if (typeof store.syncFBB === 'function') store.syncFBB();
      } catch (e) {}
    },

    /**
     * Add multiple flavor variants to cart via AJAX.
     * Called when the ATC form is submitted and any flavor qty selector has qty > 0.
     */
    addMultipleToCart(form, items) {
      // Attach selling plan to each item if subscribe mode is active
      const sellingPlanInput = form.querySelector('.product-selling-plan-id');
      const sellingPlanId = sellingPlanInput?.value ? parseInt(sellingPlanInput.value) : null;
      if (sellingPlanId) {
        items.forEach(item => { item.selling_plan = sellingPlanId; });
      }

      // Disable submit button while adding
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.querySelector('.loading__spinner')?.classList.remove('hidden');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          console.error('[FBB] Cart add error:', data);
          return;
        }
        if (typeof Alpine !== 'undefined' && Alpine.store('cart')?.refreshCart) {
          Alpine.store('cart').refreshCart();
        } else {
          const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cartEl) {
            // Adapt multi-item response: use first item key for notification render
            const adapted = { ...data.items[0], sections: data.sections };
            cartEl.renderContents(adapted);
          } else {
            window.location = window.routes?.cart_url || '/cart';
          }
        }
      })
      .catch(err => console.error('[FBB] addMultipleToCart error:', err))
      .finally(() => {
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      });
    },
  }));
});